import { useContext, useRef, useEffect } from "react"
import { useAnalytics } from "src/lib/analytics"
import { getTrackPropertiesFromState, RedemptionContext } from "@dapperlabs/redeem.js"

export function AnalyticsTracker () {
  const lastTrackRef = useRef(null)
  const { redemptionService } = useContext(RedemptionContext)
  const { track } = useAnalytics()

  useEffect(() => {
    const tListener = (state, event) => {
      const stateValue = state.toStrings()
      const thisState = stateValue[stateValue.length - 1]

      // prevents double-tracking the same event on internal or repeated transitions
      if (thisState === lastTrackRef.current) return
      lastTrackRef.current = thisState

      const trackName = `transitionTo-${thisState}`
      const trackProperties = {
        ...getTrackPropertiesFromState(state),

        // true when transition from COLLECTION.CHECKING to REDEEM.REDEEMING
        // false when transition from COLLECTION.CHECKING to COLLECTION.PREPARING
        isInitialized: event?.data?.isInitialized,
      }

      track(trackName, trackProperties)
    }

    redemptionService.onTransition(tListener)
    return () => {
      redemptionService.off(tListener)
    }
  }, [redemptionService, track])
  return null
}
